import { SettlementCategory } from '../../../features/settlementClassification/types';

/**
 * 수강권 상품 모달의 「정산 분류」 한 줄을 보일지.
 *
 * 새 기능을 안 쓰는 센터에게는 모달이 바꾸기 전과 같아야 한다. 그래서
 * - 서버에 분류 기능이 있고(GET 200) **고를 분류가 1개 이상**일 때,
 * - 또는 이 상품에 이미 분류가 있을 때(값을 지우거나 바꿀 수 있어야 한다)만 보인다.
 * 예외 수업료가 세 정산 방식 모두에서 계산되므로(PLAN_EXCEPTION_RATES_ALL_MODES §6) 정산 방식은 보지 않는다 —
 * 분류는 예외 수업료 창 「분류 관리」에서만 만들어지므로, 분류가 있다는 것 자체가 이 기능을 쓰는 센터라는 뜻이다.
 * 첫 분류 만들기는 요율 화면의 예외 수업료 창 「분류 관리」에서 한다.
 */
export const shouldShowSettlementCategoryField = ({
    available,
    currentKey,
    activeCategoryCount,
}: {
    available: boolean;
    /** 호출부 호환용 — 더는 보지 않는다(세 정산 방식 모두 예외 수업료를 계산). */
    settlementType?: string;
    currentKey: string | null | undefined;
    activeCategoryCount: number;
}) => available && (!!currentKey || activeCategoryCount > 0);

/**
 * 분류 칸이 없을 때(상세 정산 센터인데 고를 분류가 0개) 보이는 「정산 분류 만들기」 한 줄.
 * 칸 자체는 그대로 숨기고(새 기능을 안 쓰는 센터의 모달 모양 유지), 첫 분류를 만들 입구만 준다.
 */
export const shouldShowCreateCategoryEntry = ({
    available,
    settlementType,
    currentKey,
    activeCategoryCount,
    isReadOnly,
}: {
    available: boolean;
    settlementType?: string;
    currentKey: string | null | undefined;
    activeCategoryCount: number;
    isReadOnly: boolean;
}) => available && !isReadOnly && settlementType === 'tier' && !currentKey && activeCategoryCount === 0;

/** 고를 수 있는 분류: 보관 안 된 것 + 지금 값(보관됐거나 목록에 없어도 사라지지 않게). */
export const buildSettlementCategoryOptions = (
    categories: SettlementCategory[],
    currentKey: string | null,
): { value: string; label: string; disabled?: boolean }[] => {
    const options = categories.filter((c) => !c.archived).map((c) => ({ value: c.key, label: c.name }));
    if (currentKey && !options.some((o) => o.value === currentKey)) {
        const current = categories.find((c) => c.key === currentKey);
        options.push({
            value: currentKey,
            label: current ? `${current.name} (보관됨)` : '알 수 없는 분류',
        });
    }
    return options;
};

